/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {Animal} from '../../../_models/animal';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {AnimalService} from '../../../_services/animal.service';
import {ToastrService} from 'ngx-toastr';
import {DialogHelper} from '../../../_helpers/dialog-helper';
import {Helpers} from '../../../helpers';
import {IN} from '../../../_enums/operators';
import {DEFAULT, EMBEDDED} from '../../../_enums/serializer-groups';
import {I18nService} from '../../../_services/i18n.service';

@Component({
  selector: 'app-table-boviclic-animals',
  templateUrl: './table-boviclic-animals.component.html',
  styleUrls: ['./table-boviclic-animals.component.scss']
})
export class TableBoviclicAnimalsComponent implements OnInit, OnChanges {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              COMPONENT I/O                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() controlName?: string;
  @Input() formGroup?: FormGroup;
  @Input() ids: number[];
  @Input() submitted?: boolean;

  @Output() updated = new EventEmitter<Animal[]>();

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PROPERTIES                                                                                            ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public data: Animal[] = [];

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    private dataService: AnimalService,
    private dialogHelper: DialogHelper,
    private formBuilder: FormBuilder,
    private i18n: I18nService,
    private toastr: ToastrService
  ) {
    this.controlName = 'animals';
    this.formGroup = null;
    this.submitted = false;
    this.ids = [];
  }

  ngOnInit() {
    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadData();
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              REMOVAL FORM CONTROLS                                                                                 ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get dataFA(): FormArray | null {
    return this.formGroup ? this.formGroup.get(this.controlName) as FormArray : null;
  }

  autopsyFormGroup(index: number): FormGroup | null {
      return this.dataFA?.at(index) as FormGroup
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUES GETTERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public showAutopsy(d: Animal): boolean {
    return d.number && 0 < d.number.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              FORMS INITIALISATION                                                                                  ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private initAnimalFormControls() {
    this.data.forEach((d: Animal, i: number) => {
      this.dataFA.setControl(i, this.formBuilder.group({
        dateOfBirth: d.dateOfBirth,
        quantity: d.quantity,
        atm: d.atmId,
        weightE: d.weightE,
        autopsy: d.autopsyId,
        country: d.countryId,
        animalDetail: d.animalDetailId,
        number: d.number
      }));
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              CHANGE LISTENER                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public onAutopsyChange(e, i: number) {
    if (e) {
      this.dialogHelper.showConfirmAutopsy(e).subscribe((res: boolean) => {
        if (!res) {
          this.dataFA.controls[i].get('autopsy').setValue(null);
        }
      });
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              ASYNC INITIALISATION                                                                                  ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private loadData() {
    this.dataService.findBoviclic({
      filter: ['id', IN, this.ids],
      serializerGroups: [DEFAULT, EMBEDDED],
      version: 0.6
    }).subscribe((res: HttpResponse<Animal[]>) => {
      this.data = res.body;
      this.initAnimalFormControls();
    }, (err: HttpErrorResponse) => this.handleError(err));
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PRIVATE METHODS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private handleError(err: HttpErrorResponse): void {
    Helpers.setLoading(false);
    this.toastr.error(`${err.status} - ${this.i18n.get(err.status)}`);
  }

}

